// user state
import axios from "axios";
import Links from "@/shared/constants/Links";
import LoginUtil from "../../../login/LoginUtil";

const state = {
    user: null,
    systemSettings: null,
    globalConfig: null,
    programmeTypes: [],
    currentProgrammeType: null,
    currentSession: null,
    modeOfEntries: [],
    currentProgrammeType: {},
    myCourses: [], // for lecturers
    audit: [],
};


const actions = {
    async fetchCurrentUser() {
        return await axios.get("get-current-user")
    },

    async fetchProgrammeTypes(){
        return await axios.get(Links.programmeTypes.all)
    },

    logout: async () => {
        // End the session server-side. Swallow errors: if the token is
        // already invalid the call may 401 — we still clear locally.
        try {
            await axios.post(Links.auth.logout)
        } catch (e) {
            // ignore — local cleanup below is what matters
        }
        LoginUtil.resetAccessToken();
        LoginUtil.resetRefreshToken();
    }
}

const getters = {
    getUser: state => state.user,
    getMyCourses: state => state.myCourses,
    getProgrammeTypes: state => state.programmeTypes,
    getCurrentProgrammeType: state => state.currentProgrammeType,
    getCurrentSession: state => state.currentSession,
    getModeOfEntries: state => state.modeOfEntries,
    getSystemSettings: state => state.systemSettings,
    getGlobalConfig: state => state.globalConfig,
    getMyAuditRecord: state => state.content
}

const mutations = {
    setCurrentUser: (state, data) => {
        state.user = data.user
    },
    setGlobalConfig: (state, data) => (state.globalConfig = data),
    setProgrammeType: (state, data) => (state.programmeTypes = data),
    setCurrentProgrammeType: (state, data) => (state.currentProgrammeType = data),
}

export default {
    state,
    actions,
    getters,
    mutations
}
